<!-- Component that shows a fixed footer content -->

<template lang="html">
  <v-footer app absolute dark>
    <v-card class="flex">
      <v-card-actions class="justify-center">
        &copy;{{ new Date().getFullYear() }} — Superintendência de Tecnologia da Informação - UFES
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
  }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// footer.vue?8d60f2f6